import { useState } from "react";
import { motion } from "framer-motion";
import { Quote, UserRound } from "lucide-react";

export function ChairmanQuote() {
  const [imgOk, setImgOk] = useState(true);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20" data-testid="landing-chairman-section">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
        className="relative overflow-hidden rounded-[2rem] bg-[#2A1F1B] text-white grid md:grid-cols-[280px_1fr] lg:grid-cols-[320px_1fr]">
        <div className="absolute -top-16 -right-16 h-56 w-56 rounded-full bg-[#E5A93C]/15" />
        <div className="absolute -bottom-20 left-1/3 h-64 w-64 rounded-full bg-[#B85C38]/15" />

        <div className="relative p-6 sm:p-8 flex items-center justify-center">
          <div className="relative">
            <div className="absolute -inset-3 rounded-[1.75rem] bg-[#E5A93C]/25 rotate-3" />
            <div data-testid="chairman-photo" className="relative h-64 w-52 sm:h-72 sm:w-60 rounded-[1.5rem] overflow-hidden bg-[#4A2E2B] border-4 border-[#E5A93C] shadow-xl flex items-center justify-center">
              {imgOk ? (
                <img src="/ketua-kwarcab.jpg" alt="Wahid Suryono, S.Pi — Ketua Kwarcab Gerakan Pramuka Kota Depok"
                  className="h-full w-full object-cover object-top" onError={() => setImgOk(false)} />
              ) : (
                <div className="text-center px-4">
                  <UserRound className="h-16 w-16 text-[#E5A93C]/60 mx-auto" />
                  <div className="mt-3 text-[11px] uppercase tracking-widest font-bold text-white/50">Foto Ketua Kwarcab</div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="relative p-6 sm:p-10 lg:p-12 flex flex-col justify-center">
          <Quote className="h-10 w-10 text-[#E5A93C] mb-4" />
          <blockquote data-testid="chairman-quote" className="font-display text-lg sm:text-xl lg:text-2xl font-semibold leading-relaxed text-white/95">
            “Pramuka Kota Depok maju dengan peran serta seluruh aspek terutama pembina, orang tua peserta didik,
            masyarakat, pemerintah daerah, dan tentunya para pengurus kwartir.”
          </blockquote>
          <div className="mt-6 flex items-center gap-3">
            <div className="h-px w-10 bg-[#E5A93C]" />
            <div>
              <div data-testid="chairman-name" className="font-display font-extrabold text-[#E5A93C]">Wahid Suryono, S.Pi</div>
              <div data-testid="chairman-title" className="text-sm text-white/70">Ketua Kwartir Cabang Gerakan Pramuka Kota Depok</div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
